import { motion } from 'framer-motion'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { GraphStats } from '@widgets/graphStats'

import { Btn } from '@shared/ui/btn'

// import { useTgData } from '@shared/lib/useTgData'

const StatsPage = () => {
  const { t } = useTranslation()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="mt-3">
        <Btn design={['text-link']} link="/">
          <i className="fa-solid fa-arrow-left me-2" />
          {t('buttons:goToMain')}
        </Btn>
      </div>

      <GraphStats />
    </motion.div>
  )
}

export default memo(StatsPage)
